import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class InstallPromptService {
  public deferredPrompt: any = null;
  constructor(private toastr: NotificationService) {
    window.addEventListener('beforeinstallprompt', event=>{
      event.preventDefault();
      this.deferredPrompt=event;
    });
  }

  public promptInstall(): void{
    if(this.deferredPrompt){

      this.deferredPrompt.userChoice.then((choiceResult:any)=>{
        if (choiceResult.outcome === 'accepted'){
          console.log('User acccepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        //reset deferred prompt
        this.deferredPrompt=null;
      });
      this.deferredPrompt.prompt();
    } else {
      this.toastr.error('Install prompt not available')
    }
  }
}
